// Registers the build-generated Workbox service worker and applies updates for PWA users.
/* eslint-disable no-console */

import {
  activateWaitingServiceWorker,
  isStandaloneDisplayMode,
  notifyServiceWorkerUpdatePending,
  reloadForServiceWorkerUpdate,
  shouldDeferServiceWorkerReload,
} from './pwa/pwaServiceWorkerUpdates';

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d?\d)){3}$/,
    ),
);

let controllerChangeBound = false;

function bindControllerChangeReload() {
  if (controllerChangeBound || !('serviceWorker' in navigator)) return;
  controllerChangeBound = true;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (shouldDeferServiceWorkerReload()) {
      notifyServiceWorkerUpdatePending();
      return;
    }
    reloadForServiceWorkerUpdate();
  });
}

function handleWaitingWorker(registration, config) {
  if (!registration?.waiting || !navigator.serviceWorker.controller) return;

  if (config?.onUpdate) {
    config.onUpdate(registration);
    return;
  }

  if (shouldDeferServiceWorkerReload()) {
    notifyServiceWorkerUpdatePending();
    return;
  }

  activateWaitingServiceWorker(registration);
}

function watchRegistration(registration, config) {
  if (!registration) return;

  registration.addEventListener('updatefound', () => {
    const installingWorker = registration.installing;
    if (!installingWorker) return;

    installingWorker.addEventListener('statechange', () => {
      if (installingWorker.state !== 'installed') return;
      if (!navigator.serviceWorker.controller) {
        config?.onSuccess?.(registration);
        return;
      }
      handleWaitingWorker(registration, config);
    });
  });

  // Worker may already be waiting from a prior visit.
  handleWaitingWorker(registration, config);
}

function checkForServiceWorkerUpdate() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.update())
    .catch(() => {});
}

function bindUpdateTriggers() {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkForServiceWorkerUpdate();
    }
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted || isStandaloneDisplayMode()) {
      checkForServiceWorkerUpdate();
    }
  });

  window.setInterval(checkForServiceWorkerUpdate, 60 * 60 * 1000);
}

export function register(config) {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) return;

  bindControllerChangeReload();
  bindUpdateTriggers();

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config);
      return;
    }

    registerValidSW(swUrl, config);
  });
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      watchRegistration(registration, config);
      return registration.update();
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready
          .then((registration) => registration.unregister())
          .then(() => window.location.reload());
        return;
      }
      registerValidSW(swUrl, config);
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {});
}
